export interface ConfigData {
  apiUri: string
  innerApiUri: string
  env: string
  prefix: string
  hmacKey: string
  youtubeApiKey?: string
  youtubeEnChannel?: string
  pureApiUrl?: string
  pureApiKey?: string
  host: string

  mailToLink: string
  siteName: string
  siteUrl: string
}

const DEFAULT_ENV = "development"
const DEFAULT_PREFIX = "/content"
const DEFAULT_MAIL_TO_LINK = "mailto:feedback@pure.app"
const DEFAULT_SITE_NAME = "Pure"
const DEFAULT_SITE_URL = "https://pure.app"
const DEFAULT_HOST = "pure.app"

export class Config {
  data: ConfigData

  constructor() {
    this.data = {
      apiUri: process.env.NEXT_PUBLIC_API_URI ?? "",
      innerApiUri:
        process.env.INNER_API_URI ?? process.env.NEXT_PUBLIC_API_URI ?? "",
      env: process.env.ENVIRONMENT ?? DEFAULT_ENV,
      prefix: process.env.NEXT_PUBLIC_FRONTEND_PREFIX ?? DEFAULT_PREFIX,
      hmacKey: process.env.NEXT_PUBLIC_HMAC_KEY ?? "",
      youtubeApiKey: process.env.YOUTUBE_API_KEY,
      youtubeEnChannel: process.env.YOUTUBE_EN_CHANNEL,
      pureApiUrl: process.env.NEXT_PUBLIC_PURE_API_URL,
      pureApiKey: process.env.NEXT_PUBLIC_PURE_API_KEY,
      host: process.env.HOST || DEFAULT_HOST,

      mailToLink: DEFAULT_MAIL_TO_LINK,
      siteName: DEFAULT_SITE_NAME,
      siteUrl: DEFAULT_SITE_URL,
    }
  }

  hydrate = (data: unknown) => {
    // @ts-ignore
    this.data = data.data
  }

  serialize = () => {
    return {
      data: this.data,
    }
  }
}

export const config = new Config()
